export default __webpack_public_path__ + "static/media/area-15.47426752.jpg";